import { isDisabled } from "@testing-library/user-event/dist/utils";
import { DatePicker, Form, Select } from "antd";
import { Radio } from "antd";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import React, { FC } from "react";

type AdmissionInformationProps = {
  form: any;
  dateFormat: string;
  isDisabled?: any;
  admissionDateValue?: any;
};

const AdmissionInformation: FC<AdmissionInformationProps> = ({
  form,
  dateFormat,
  isDisabled,
  admissionDateValue,
}) => {
  return (
    <>
      <h2>ADMISSION INFORMATION</h2>

      <h3 style={{ margin: "14px 0" }}>ADMISSION DETAILS</h3>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="ADMISSION DATE"
            name="admissionDate"
            rules={[
              { required: true, message: "Please select admission date" },
            ]}
          >
            <DatePicker
              allowClear
              style={{ width: "100%" }}
              showTime
              format={dateFormat}
              disabled={isDisabled}
              disabledDate={(current) => {
                const today = dayjs();
                today.startOf("day");

                const twoDaysAgo = dayjs().subtract(2, "day").startOf("day");

                return (
                  current &&
                  (current.isBefore(twoDaysAgo) || current.isAfter(today))
                );
              }}
              onChange={() => {
                form.setFieldsValue({ surgeryDate: null });
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="SURGERY TREATMENT START DATE"
            name="surgeryDate"
            rules={[{ required: true, message: "Please select surgery date" }]}
          >
            <DatePicker
              allowClear
              style={{ width: "100%" }}
              showTime
              format={dateFormat}
              disabled={!admissionDateValue || form.disabled || isDisabled}
              disabledDate={(current) => {
                const admissionDate = form.getFieldValue("admissionDate");
                if (!admissionDate) return true;

                const admissionDayjs = dayjs.isDayjs(admissionDate)
                  ? admissionDate
                  : dayjs(admissionDate);

                const maxDate = admissionDayjs.add(10, "day").endOf("day");

                return (
                  current &&
                  (current.isBefore(admissionDayjs.startOf("day")) ||
                    current.isAfter(maxDate))
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="ADMISSION TYPE"
            name="admissionType"
            rules={[
              { required: true, message: "Please select admission type" },
            ]}
          >
            <Select placeholder="Select" disabled={isDisabled}>
              <Select.Option value="Planned">PLANNED</Select.Option>
              <Select.Option value="Emegency">EMERGENCY</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="MEDICO LEGAL CASE"
            name="medicoLegalCase"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group disabled={isDisabled}>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default AdmissionInformation;
